import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(private snackBar: MatSnackBar) { }

  popSnackBar(message: string, durationInSecs: number = 5, infinite: boolean = false) {
    this.snackBar.open(message, 'Fechar', {
      duration: infinite ? undefined : durationInSecs * 1000,
      panelClass: 'generic-snackbar',
    });
  }
}
